/** Keep sign-in returns inside INBDE, with the review bench entered from its tab. */
export function loginDestination(requestedNext: string | null, brand: string): string {
  const fallback = brand === 'inbde' ? '/inbde' : '/dashboard';
  if (!requestedNext || !/^\/inbde(?:\/|\?|#|$)/.test(requestedNext)
    || requestedNext.includes('\\') || Array.from(requestedNext).some((character) => character.charCodeAt(0) <= 32)) return fallback;
  const destination = new URL(requestedNext, 'https://login.invalid');
  if (destination.origin !== 'https://login.invalid' || !/^\/inbde(?:\/|$)/.test(destination.pathname)) return fallback;
  if (/^\/inbde\/review(?:\/|$)/.test(destination.pathname)) return '/inbde';
  return destination.pathname + destination.search + destination.hash;
}
